// Ciro aktarım audit trail mutation'ları.
// CiroAktarPage'de bir aktarım iki şey yapar:
//   1) user_revenue_entries.ceyrek/yil günceller (taşıma)
//   2) revenue_transfer_log'a kim, nereden, nereye, ne zaman kaydı atar
// İki mutation tek GraphQL operasyonu olarak gönderiliyor — Hasura aynı
// transaction'da çalıştırır, kısmi başarısızlık olmaz.

export const TRANSFER_REVENUE_ENTRY_MUTATION = `
  mutation TransferRevenueEntry(
    $entryId: Int!,
    $newYear: Int!,
    $newQuarter: Int!,
    $logObject: revenue_transfer_log_insert_input!
  ) {
    update_user_revenue_entries_by_pk(
      pk_columns: { id: $entryId }
      _set: { yil: $newYear, ceyrek: $newQuarter }
    ) {
      id
      yil
      ceyrek
    }
    insert_revenue_transfer_log_one(object: $logObject) {
      id
      entry_id
      from_year
      from_quarter
      to_year
      to_quarter
      transferred_at
      transferred_by
      note
    }
  }
`;
